import { BaseModel } from "sjs-base-model";

export default class KaikoPricingPackageModel extends BaseModel {
    id = 0;
    name = "";
    numberOfItems = 0;
    // TODO: add a currency name field - for e.g. BTC
    price = 0;

    constructor(data) {
        super();
        this.update(data);
    }
}
